import React, { Component } from "react";
import { FeatureGroup } from "react-leaflet";
import L from "leaflet";
import $ from "jquery";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { EditControl } from "react-leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import { connect } from "react-redux";
import { helper } from "../../../../utils/helpers/helper";
import { drawingActions, mapActions } from "../../../../store/actions";
import { Button } from "tabler-react";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0/images/marker-icon.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0/images/marker-shadow.png",
});

let coord = {
  points: [],
};
let layer;

class DrawingComponent extends Component {
  state = {
    currentLayer: null,
  };
  constructor(props) {
    super(props);
    this.drawingtool = React.createRef();
  }

  _onCreated = async (e) => {
    let type = e.layerType;
    // let layer = e.layer;
    if (type === "marker") {
      // Do marker specific actions
    } else {
      coord.points = [];
      let myCoordinates = coord.points;
      let coordIndex = null;
      layer = e.layer;
      const coordinates = layer.getLatLngs();
      if (type === "polyline") {
        coordinates.map(function (val, index) {
          coordIndex = [val.lat, val.lng];
          myCoordinates.push(coordIndex);
          return null;
        });
      } else {
        coordinates.map(function (val, index) {
          val.map(function (value, i) {
            coordIndex = [value.lat, value.lng];
            myCoordinates.push(coordIndex);
            return null;
          });
          return null;
        });
      }
      //drawEnd: set to true
      const requestData = {
        status: "request",
        coord,
        layer,
      };
      this.props.drawing(requestData);
    }
  };

  _createCustomPopup = (card, popupText, polyData, layer) => {
    // Card Header
    var cardHeader = document.createElement("div");
    cardHeader.className = "card-header";
    // polyPopUp
    var polyPopUp = document.createElement("div");
    polyPopUp.className = "col-md-12 ml-0 mr-0 pl-0 pr-0 polyPopUp";
    // polyPopUpContent
    var polyPopUpContent = document.createElement("div");
    polyPopUpContent.className = "ml-0 mr-0 pl-0 pr-0 popup-poly-content";
    polyPopUpContent.innerHTML = popupText;
    cardHeader.appendChild(polyPopUpContent);
    // polyPopUpUseractions
    var polyPopUpUseractions = document.createElement("div");
    polyPopUpUseractions.className = "leaflet-popup-useraction-buttons";
    // polyPopUpRemove
    var polyPopUpRemove = document.createElement("BUTTON");
    polyPopUpRemove.className = "leaflet-popup-button remove mr-4";
    polyPopUpRemove.innerHTML = "Remove geofence";
    polyPopUpRemove.onclick = (e) => this._deletePopup(polyData.id, layer);
    // polyPopUpEdit
    var polyPopUpEdit = document.createElement("BUTTON");
    polyPopUpEdit.className = "leaflet-popup-button edit";
    polyPopUpEdit.innerHTML = "Edit geofence";
    polyPopUpEdit.onclick = (e) => this._editPopup(polyData, layer);

    polyPopUpUseractions.append(polyPopUpRemove, polyPopUpEdit);
    card.append(cardHeader, polyPopUpUseractions);
    return card;
  };

  _deletePopup = (polyDataId, layer) => {
    this.props.map.removeLayer(layer);
    this.props.deletePolygonAction(polyDataId);
  };

  _editPopup = (polyData, layer) => {
    this.props.updatePreference(polyData, layer);
  };

  _onMounted = (drawControl) => {
    // console.log("_onMounted", drawControl);
  };

  _onDrawStart(e) {
    
    let localStorageSubscription = JSON.parse(
      localStorage.getItem("subscription_details")
    );
    let drawControl = this.drawingtool.current.leafletElement;
    
    //ACCESS TO ADMIN AND USER LEVEL 2
    if (
      localStorageSubscription?.subscription_level === null ||
      localStorageSubscription?.subscription_level === 2
    ) {
    const map = this.props.map;
    
    // ADD TOOLTIP ON DRAWING START
    var tooltip = L.DomUtil.get("tooltip");
    // var Z = 90, latlng, redoBuffer = [];
    function addTooltip(e) {
      tooltip.innerHTML = "Click on the map to start a line.";
      tooltip.style.display = "block";
    }

    function removeTooltip(e) {
      tooltip.innerHTML = "";
      tooltip.style.display = "none";
      L.DomEvent.off(document, "mousemove", moveTooltip);
    }

    function moveTooltip(e) {
      tooltip.style.left = e.clientX + 20 + "px";
      tooltip.style.top = e.clientY - 10 + "px";
    }

    function updateTooltip(e) {
      if (e.layer.editor._drawnLatLngs.length < e.layer.editor.MIN_VERTEX) {
        tooltip.innerHTML = "Click on the map to continue line.";
      } else {
        tooltip.innerHTML = "Click on last point to finish line.";
      }
    }
    map.on("editable:drawing:start", addTooltip);
    map.on("editable:drawing:end", removeTooltip);
    map.on("editable:drawing:click", updateTooltip);
    // HIDE Geofencing DROPDOWN IF IS OPEN
    if (this.props.showMyPolygonList === true) {
      this.props.showMyPolygonListAction(false);
    }
    // PERMISSION FOR SUBSCRIPTION USERS
    let subscription = this.props.subscription;
    let localStorageSubscription = JSON.parse(
      localStorage.getItem("subscription_details")
    );
    } else{
      //DISABLE DRAWING
      drawControl.setDrawingOptions({
        draw: false,
      });
      drawControl._toolbars["draw"].disable();
      confirmAlert({
        // title: 'Confirm Please',
        message:
          "This feature is not included in your subscription package. Please contact WB to access this feature.",
        buttons: [
          {
            label: "Ok",
            onClick: () => {
              // DISABLE DRAWING CONTROL FROM MAP
              drawControl._toolbars["draw"].disable();
            },
          },
        ],
      });
    }
  }

  _onDrawStop = (e) => {
    // Do whatever else you need to. (save to db, add to map etc)
  };

  _onEditStart = (e) => {
    // console.log("_onEditStart", e);
  };

  _onEditStop = (e) => {
    // console.log("_onEditStop", e);
  };

  _onDeleted = (e) => {
    // let numDeleted = 0;
    // e.layers.eachLayer((layer) => {
    //   numDeleted += 1;
    // });

    this._onChange();
  };

  _onDeleteStart = (e) => {
    // console.log("_onDeleteStart", e);
  };

  _onDeleteStop = (e) => {
    // console.log("_onDeleteStop", e);
  };

  _onDrawVertex = (e) => {
    // alert('_onDrawVertex');
    // let drawControl = this.drawingtool.current.leafletElement;
    if (Object.keys(e.layers._layers).length > 1) {
      // need to close polyline here
      // let layerVertex = e.layers._layers;
      // console.log(typeof layerVertex)
      // console.log(layerVertex)
      // let last = layerVertex[Object.keys(layerVertex)[Object.keys(layerVertex).length - 1]] // "carrot"
      // let poly = drawControl._toolbars.draw._modes.polygon.handler._poly;
      // var lastLatLng = this._poly._latlngs[this._poly._latlngs.length - 1];
    }
  };

  componentDidMount() {
    $(".leaflet-draw-draw-polygon").attr("title", "Add Geofence");
    // $(".leaflet-control-layers > a").innerHTML('Layers');
  }

  componentWillReceiveProps(nextProps) {
    const {
      newPolygon,
      newPolyData,
      leafletLayer,
      editDrawing,
      editPolyData,
    } = nextProps;
    if (
      newPolygon === true &&
      this.props.newPolygon !== nextProps.newPolygon &&
      layer !== null
    ) {
      // Save polygon on map layer to reducer
      this.props.saveDrawingLayer(newPolyData, layer);
      // Save drawn polygon on map layer
      this.props.map.addLayer(layer);
      // CREATE POPUP CONTENT FOR NEW POLYGON
      const content = newPolyData.support_data;
      let popupText = `Geofence: ${helper.capitalizeFirstLetter(
        content?.title
      )}<br/>`;
      popupText += `Alerts: ${helper.capitalizeFirstLetter(
        content?.alert
      )}<br/>`;
      popupText += `Status: ${helper.capitalizeFirstLetter(
        content?.status
      )}<br/>`;
      popupText +=
        helper.get_user_role() === "admin"
          ? `Created by: ${helper.capitalizeFirstLetter(
              newPolyData?.created_by?.email
            )}<br/>`
          : "";
      var card = document.createElement("div");
      let popupContent = this._createCustomPopup(
        card,
        popupText,
        newPolyData,
        layer
      );
      layer.bindPopup(popupContent);
    }
    // This check will delete layer of unfilled form
    else if (nextProps.deleteCurrentDrawingLayer === true) {
      let currentLayer = nextProps.currentDrawingLayer;
      this.props.map.removeLayer(currentLayer);
      this.props.deleteLayer();
    }
    if (editDrawing !== false && editDrawing !== true) {
      leafletLayer.map((obj) => {
        if (obj.id === editDrawing) {
          let layer = obj.layer;
          // EDIT POPUP CONTENT FOR POLYGON
          const contentUpdated = editPolyData.support_data;
          let popupText = `Geofence Title: ${helper.capitalizeFirstLetter(
            contentUpdated?.title
          )}<br/>`;
          popupText += `Alerts: ${helper.capitalizeFirstLetter(
            contentUpdated?.alert
          )}<br/>`;
          popupText += `Status: ${helper.capitalizeFirstLetter(
            contentUpdated?.status
          )}<br/>`;
          popupText +=
            helper.get_user_role() === "admin"
              ? `Created by: ${helper.capitalizeFirstLetter(
                  editPolyData?.created_by?.email
                )}<br/>`
              : "";
          var cardUpdated = document.createElement("div");
          let popupContent = this._createCustomPopup(
            cardUpdated,
            popupText,
            editPolyData,
            layer
          );
          layer.bindPopup(popupContent);
        }
        return null;
      });
    }
  }

  render() {
    
    
    return (
      <>
        <FeatureGroup
        // ref={ (reactFGref) => {this._onFeatureGroupReady(reactFGref);} }
        >
          <EditControl
            ref={this.drawingtool}
            position="topright"
            // onEdited={this._onEdited}
            edit={{ edit: false, remove: false }}
            onCreated={this._onCreated}
            onDeleted={this._onDeleted}
            onMounted={this._onMounted}
            onDrawStart={(e) => this._onDrawStart(e)}
            onDrawStop={this._onDrawStop}
            onDrawVertex={this._onDrawVertex}
            // onEditStart={this._onEditStart}
            // onEditStop={this._onEditStop}
            onDeleteStart={this._onDeleteStart}
            onDeleteStop={this._onDeleteStop}
            draw={{
              toolbar: {
                buttons: {
                  polygon: "Draw an awesome polygon",
                },
              },
              rectangle: false,
              circle: false,
              marker: false,
              circlemarker: false,
              polyline: false,
            }}
          />
        </FeatureGroup>
        <div id="tooltip"></div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { loggedOut } = state.authentication;
  const { subscription } = state.user;
  const { alert } = state;
  const { showMyPolygonList } = state.map;
  const {
    deleteCurrentDrawingLayer,
    currentDrawingLayer,
    drawEnd,
    editPolyData,
    newPolygon,
    newPolyData,
    editPolygon,
    editDrawing,
    leafletLayer,
  } = state.drawing;
  return {
    showMyPolygonList,
    deleteCurrentDrawingLayer,
    currentDrawingLayer,
    loggedOut,
    subscription,
    alert,
    drawEnd,
    editPolyData,
    newPolygon,
    newPolyData,
    editPolygon,
    editDrawing,
    leafletLayer,
  };
}

const mapDispatchToProps = {
  deleteLayer: drawingActions.deleteCurrentDrawingLayer,
  saveDrawingLayer: drawingActions.saveDrawingLayer,
  showMyPolygonListAction: mapActions.showMyPolygonListAction,
  drawing: drawingActions.drawing,
  deletePolygonAction: drawingActions.deletePolygon,
  setPreference: drawingActions.setPreference,
  updatePreference: drawingActions.updatePreference,
};
export default connect(mapStateToProps, mapDispatchToProps)(DrawingComponent);
